import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-bild-entfernen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentBildEntfernenEffects {

    IncidentBildEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_BILD_ENTFERNEN),
        mergeMap((x: ac.PostIncidentBildEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentBildEntfernen(x.incidentBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentBildEntfernenErfolgreichAction(result, x.incidentBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentBildEntfernenFehlerAction(error, x.incidentBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
